import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MixedLoyaltyItemComponent } from './mixed-loyalty-item.component';
import { AuctionPanelModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-panel';
import { MarketplaceListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list-item';
import { MarketplaceListItemV2Component } from '@fgb/portal-component-library/src/lib/loyalty/marketplace';
import { LottosListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import { LottosListItemV2Component } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-v2';

@NgModule({
  declarations: [MixedLoyaltyItemComponent],
  imports: [CommonModule, AuctionPanelModule, MarketplaceListItemModule, MarketplaceListItemV2Component, LottosListItemModule, LottosListItemV2Component],
  exports: [MixedLoyaltyItemComponent],
})
export class MixedLoyaltyItemModule {}
